<template>
	<v-app id="app">
		<!-- <app-navigation></app-navigation> -->
		<app-navigation v-if="showAppNavigation"></app-navigation>

		<v-main transition="slide-x-transition">
			<router-view></router-view>
		</v-main>

		<eVatNotification v-if="showEVatNotification"></eVatNotification>

		<!-- <fy1400></fy1400> -->

		<app-footer v-if="showAppNavigation"></app-footer>
		<!-- <app-footer></app-footer> -->
	</v-app>
</template>

<script>
import AppNavigation from "@/components/AppNavigation";
import eVatNotification from "@/ut/eVatNotification";
// import fy1400 from "@/ut/fy1400";
import AppFooter from "@/components/AppFooter";

export default {
	rtl: true,
	name: "App",
	components: {
		AppNavigation,
		eVatNotification,
		// fy1400,
		AppFooter,
	},
	data() {
		return {
			showAppNavigation: false,
			showEVatNotification: false,
		}
	},
	watch: {
		// Watch for route changes
		$route(to) {
			this.updateVisibility(to.path);
		},
	},
	methods: {
		updateVisibility(path) {
			// Update visibility based on the current route
			console.info('Route:', this.$route);
			console.info('Route Path:', this.$route.path);
			console.info('Full Path:', this.$route.fullPath);
			console.info('Matched Routes:', this.$route.matched);

			if (path === '/qst' || path.startsWith('/qst')) {
				this.showAppNavigation = false;
				this.showEVatNotification = false;
			} else {
				this.showAppNavigation = true;
				this.showEVatNotification = true;
			}
		},
	},
	mounted: async function () {
		// console.info('Route Path:', this.$route.path);
		// console.info('Full Path:', this.$route.fullPath);
		// console.info('Matched Routes:', this.$route.matched);

		// if (this.$route.path === '/qst' || this.$route.fullPath.startsWith('/qst')) {
		// 	this.showAppNavigation = false;
		// 	this.showEVatNotification = false;
		// } else {
		// 	this.showAppNavigation = true;
		// 	this.showEVatNotification = true;
		// }
		await this.$store.dispatch("checkLoged");
	},
};

// RAYCHAT
// !(function () {
// 	function t() {
// 		var t = document.createElement("script");
// 		(t.type = "text/javascript"),
// 			(t.async = !0),
// 			localStorage.getItem("rayToken") ? (t.src = "https://app.raychat.io/scripts/js/" + o + "?rid=" + localStorage.getItem("rayToken") + "&href=" + window.location.href) : (t.src = "https://app.raychat.io/scripts/js/" + o + "?href=" + window.location.href);
// 		var e = document.getElementsByTagName("script")[0];
// 		e.parentNode.insertBefore(t, e);
// 	}
// 	var e = document,
// 		a = window,
// 		o = "930c9df9-6085-48d0-a74a-4e19659f1133";
// 	"complete" == e.readyState ? t() : a.attachEvent ? a.attachEvent("onload", t) : a.addEventListener("load", t, !1);
// })();

</script>

<style lang="scss">
@import url("./style/global.scss");
</style>
